import React from 'react';
import parse from 'html-react-parser';

import './style.sass';

const CaseExtraSmallText = ({ children, className = '' }) => {
    return <div className={`common__extra-small-text ${className}`}>{parse(children)}</div>;
};

export default CaseExtraSmallText;
